import { swalErrorMessage } from "../../../../Constant/swalMessage";
import {
  createProjectPoolService,
  deleteProjectPoolService,
  getProjectPoolsService,
  replaceProjectPoolsService,
  updateProjectPoolService,
} from "../../services/projectPools.services";

const errorMessage = (err) =>
  err?.response?.data?.detail || err?.errMsg || err?.message || "Request failed";

export const getProjectPoolsAction = () => async () => {
  try {
    return await getProjectPoolsService();
  } catch (err) {
    swalErrorMessage(errorMessage(err));
    throw err;
  }
};

export const createProjectPoolAction = (data) => async () => {
  try {
    return await createProjectPoolService(data);
  } catch (err) {
    swalErrorMessage(errorMessage(err));
    throw err;
  }
};

export const updateProjectPoolAction = (id, data) => async () => {
  try {
    return await updateProjectPoolService(id, data);
  } catch (err) {
    swalErrorMessage(errorMessage(err));
    throw err;
  }
};

export const deleteProjectPoolAction = (id, force = false) => async () => {
  try {
    return await deleteProjectPoolService(id, force);
  } catch (err) {
    swalErrorMessage(errorMessage(err));
    throw err;
  }
};

export const replaceProjectPoolsAction = (pools) => async () => {
  try {
    return await replaceProjectPoolsService(pools);
  } catch (err) {
    swalErrorMessage(errorMessage(err));
    throw err;
  }
};
